var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightStepper({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87615 0.328318C1.44689 -0.10941 0.751079 -0.109469 0.321855 0.328318C-0.107285 0.766112 -0.107285 1.47583 0.321855 1.91362L7.489 9.22375C7.90563 9.64922 7.90593 10.352 7.489 10.7773L0.321855 18.0863C-0.107342 18.5241 -0.107227 19.2338 0.321855 19.6716C0.751107 20.1095 1.4469 20.1095 1.87615 19.6716L9.0433 12.3626C10.3189 11.0615 10.3189 8.93841 9.0433 7.63735L1.87615 0.328318Z",
    fill: "#083844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightStepper);
export default __webpack_public_path__ + "static/media/arrow-right-stepper.1fc66f41d07b1c0f4dca85d40f9389d8.svg";
export { ForwardRef as ReactComponent };